import { Component, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { SimulationTrackerState } from '../../../state/simulation-tracker/simulation-tracker.state';
import { SimulationTracker } from '../../interfaces/simulation-tracker';
import { PredictorModelState } from '../../../state/predictor-model/predictor-model.state';
import { StudyArea } from '../../interfaces/study-area';
import { SimulationTrackerItem } from '../../interfaces/simulation-tracker-item';
import { SimulationTrackerDataService } from '../../services/simulation-tracker-data.service';
import { FeatureFlagKey, FeaturesState } from '../../../state/features/features.state';

@Component({
  selector: 'app-simulations-page',
  templateUrl: './simulations-page.component.html',
  styleUrl: './simulations-page.component.scss'
})
export class SimulationsPageComponent implements OnInit {
  simulationTrackerItems$!: Observable<SimulationTrackerItem[]>;

  retentionDays: number;

  @Select(PredictorModelState.studyAreas) studyAreas$!: Observable<StudyArea[]>;
  @Select(SimulationTrackerState.simulationTrackers) simulationTrackers$!: Observable<SimulationTracker[]>;

  constructor(private simulationTrackerDataService: SimulationTrackerDataService, private store: Store) {
    this.retentionDays = this.store.selectSnapshot(
      FeaturesState.selectFeatureNumberByKey(
        FeatureFlagKey.SimulationHistoryLimit
      )
    );
  }

  ngOnInit(): void {
    this.loadSimulationData();
  }

  private loadSimulationData(): void {
    this.simulationTrackerItems$ = this.simulationTrackerDataService.combineStudyAreaAndSimulationTrackers(this.studyAreas$, this.simulationTrackers$, this.retentionDays)
  }
}
